import { Icon } from "@cadmakers-ui/icons";
import { CalendarPickerInput, deviceDetect } from "@cadmakers-ui/core";
import queryString from "query-string";
import React, { Dispatch } from "react";
import { connect } from "react-redux";
import { showSnack } from "react-redux-snackbar";
import { UserState } from "redux-oidc";
import { RouteComponentProps, withRouter } from "react-router";
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  FormText,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row
} from "reactstrap";
import { Application } from "../../../App/Models/Application";
import { ResponseResult } from "../../../Common/Models/ResponseResult";
import ResponseHandler from "../../../App/ResponseHandler";
import { ApiRequest, appPaths, IAppState } from "../../../Common";
import { endpoints, SubmitBugReport } from "../..";
import { updateBugReport } from "../../Actions/FeedbackFormActions";
import { FeedbackCategory, FeedbackParent } from "../../Constants/feedbackEnums";
import ImageDropzone from "../Common/ImageDropzone/ImageDropzone";
import FileUploadButton from "../../../Common/Components/FileUploadButton/FileUploadButton";
import {
  fileService,
  imageUploadService,
  feedbackService,
  fileUploadService
} from "../../Services";
import ElementSpacer from "../../../Layout/Components/ElementSpacer";
import { Topic } from "../../../Topic/Models/Topic";
import { updateTopics } from "../../../Startup/Actions/StartupActions";
import { FeedbackFormInput } from "../Common/FeedbackFormInput";
import { Image } from "../../Models/Image";
import { DeleteImage } from "../../Models/DeleteImage";
import { feedbackFormConstants } from "../../Constants/feedbackFormConstants";
import SimilarFeedbackSuggestionsContainer from "../Common/SimilarFeedbackSuggestions/SimilarFeedbackSuggestionsContainer";
import { FeedbackFile } from "../../Models/FeedbackFile";
import { DeleteFile } from "../../Models/DeleteFile";
import FeedbackFileManager from "../Common/FeedbackFileManager/FeedbackFileManager";
import FeedbackFormBugReportTypeInput from "../Common/FeedbackFormBugReportTypeInput";
import FeedbackFormIsPrivateInput from "../Common/FeedbackFormIsPrivateInput";
import iconStyles from "../../../Common/Styles/Icons.module.scss";
import { userService } from "../../../User";

type Props = {
  selectedApp?: Application;
  selectedTopic?: Topic;
  selectedParent: FeedbackParent;
  code: string;
};

type StateProps = {
  bugReport: SubmitBugReport;
  topics: Topic[];
  user: UserState;
};

type DispatchProps = {
  updateBugReport: (bugReport: SubmitBugReport) => void;
  showSnack: (uniqueId: any, args: any) => void;
  updateTopics: (topics: Topic[]) => void;
};

type State = {
  bugReport: SubmitBugReport;
  canSubmit: boolean;
  dropzoneOpen: boolean;
  images: Image[];
  files: FeedbackFile[];
  didLoadDefaults: boolean;
  inProgressCount: number;
  dueDateDatePickerActual: Date;
  startDateDatePickerActual: Date;
};

const mapStateToProps = (state: IAppState) => ({
  bugReport: state.feedbackForm.bugReport,
  topics: state.app.topics,
  user: state.oidc
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  updateBugReport: (bugReport: SubmitBugReport) => dispatch(updateBugReport(bugReport)),
  showSnack: (uniqueId: any, args: any) => dispatch(showSnack(uniqueId, args)),
  updateTopics: (topics: Topic[]) => dispatch(updateTopics(topics))
});

class BugReportForm extends React.Component<
  Props & StateProps & DispatchProps & RouteComponentProps,
  State
> {
  private imageUploadPendingCount: number;

  private fileUploadPendingCount: number;

  constructor(props: Props & StateProps & DispatchProps & RouteComponentProps) {
    super(props);

    this.state = {
      bugReport: this.props.bugReport,
      canSubmit: true,
      dropzoneOpen: false,
      images: [],
      files: [],
      didLoadDefaults: false,
      inProgressCount: 0,
      dueDateDatePickerActual: new Date(),
      startDateDatePickerActual: new Date()
    };

    this.imageUploadPendingCount = 0;
    this.fileUploadPendingCount = 0;
  }

  componentDidMount() {
    this.loadDefaultsIfNeeded();
  }

  componentWillUnmount = () => {
    this.props.updateBugReport(this.state.bugReport);
  };

  getBugReportBody = () => {
    return {
      title: this.state.bugReport.title,
      appRolePrefix: this.props.selectedApp ? this.props.selectedApp.rolePrefix : null,
      topicCode: this.props.selectedTopic ? this.props.selectedTopic.code : null,
      feedbackCategory: FeedbackCategory[FeedbackCategory.BugReport],
      feedbackParent: this.props.selectedParent,
      reproductionSteps: this.state.bugReport.reproductionSteps,
      description: this.state.bugReport.description,
      expectedBehaviour: this.state.bugReport.expectedBehaviour,
      link: this.state.bugReport.link,
      imageRefs: this.state.images,
      files: this.state.files,
      tagIds: this.state.bugReport.tagId ? [this.state.bugReport.tagId] : [],
      isPrivate: this.state.bugReport.isPrivate,
      dueDate: this.state.bugReport.dueDate,
      startDate: this.state.bugReport.startDate,
      estimatedHours: this.state.bugReport.estimatedHours,
      browserName: deviceDetect().browserName,
      browserVersion: deviceDetect().browserFullVersion
    };
  };

  clearForm = () => {
    this.setState({
      bugReport: {
        title: "",
        reproductionSteps: "",
        description: "",
        expectedBehaviour: "",
        link: "",
        tagId: undefined,
        isPrivate: true,
        estimatedHours: undefined
      }
    });
  };

  onChangeType = (tagId: number) => {
    this.setState(prevState => ({
      bugReport: { ...prevState.bugReport, tagId }
    }));
  };

  onChangeIsPrivate = (isPrivate: boolean) => {
    this.setState(prevState => ({
      bugReport: { ...prevState.bugReport, isPrivate }
    }));
  };

  onChangeDueDate = (dueDate: Date) => {
    this.setState(prevState => ({
      bugReport: { ...prevState.bugReport, dueDate }
    }));
  };

  onChangeDueDatepickerActual = (actual: Date) => {
    this.setState(prevState => ({
      dueDateDatePickerActual: actual
    }));
  };

  onChangeStartDate = (startDate: Date) => {
    this.setState(prevState => ({
      bugReport: { ...prevState.bugReport, startDate }
    }));
  };

  onChangeStartDatepickerActual = (actual: Date) => {
    this.setState(prevState => ({
      startDateDatePickerActual: actual
    }));
  };

  onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (this.imageUploadPendingCount > 0) {
      this.showErrorSnackbar(
        "Failed to submit bug report",
        "Please wait until all images are finished uploading"
      );
      return;
    }

    this.setState({
      canSubmit: false
    });

    let redirect: boolean = false;

    ApiRequest.fromPath(endpoints.feedback.create(this.props.code))
      .withAuthHeader()
      .withJson(this.getBugReportBody())
      .post()
      .then(async (response: Response) => {
        await ResponseHandler.handle(
          response,
          () => {
            if (this.props.selectedParent === FeedbackParent.Topic) {
              const topicsCopy = [...this.props.topics];
              const topicIndex = topicsCopy.findIndex(
                topic => (this.props.selectedTopic as Topic).code === topic.code
              );

              if (topicIndex !== -1) {
                topicsCopy[topicIndex].bugReportCount++;
              }

              this.props.updateTopics(topicsCopy);
            }

            this.clearForm();
            redirect = true;
          },
          (result: ResponseResult) => {
            this.showErrorSnackbar(
              "Failed to create bug report",
              result.error.message,
              response.status
            );
          },
          () => {
            this.showErrorSnackbar(
              "Failed to create bug report",
              "An unknown error has occured",
              response.status
            );
          }
        );
      })
      .finally(() => {
        this.setState({
          canSubmit: true
        });

        if (redirect && this.props.code) {
          switch (this.props.selectedParent) {
            case FeedbackParent.Application:
              this.props.history.push(
                feedbackService.getViewUrlForCodeAndAppRolePrefix(
                  this.props.code,
                  (this.props.selectedApp as Application).rolePrefix,
                  FeedbackCategory.BugReport
                )
              );
              break;
            case FeedbackParent.Topic:
              this.props.history.push(
                feedbackService.getViewUrlForCodeAndTopicCode(
                  this.props.code,
                  (this.props.selectedTopic as Topic).code,
                  FeedbackCategory.BugReport
                )
              );
              break;
            default:
              break;
          }
        }
      });
  };

  onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const { name } = event.target;

    if (name === "estimatedHours") {
      this.setState(prevState => ({
        bugReport: { ...prevState.bugReport, [name as any]: parseInt(value, 10) }
      }));
    } else {
      this.setState(prevState => ({
        bugReport: { ...prevState.bugReport, [name as any]: value }
      }));
    }
  };

  onImagesAdded = (images: Image[]) => {
    if (this.props.code) {
      this.imageUploadPendingCount += images.length;

      images.forEach(async image => {
        await imageUploadService.uploadImage(
          endpoints.feedback.images.uploadTemp(this.props.code),
          image,
          newImage => {
            this.setState(prevState => ({
              images: prevState.images.concat(newImage)
            }));
          },
          hash => {
            return this.state.images.find(x => x.fullSizeHash === hash);
          },
          () => {
            this.showErrorSnackbar(
              "Failed to upload image",
              "This image has already been uploaded"
            );
          },
          (response, result) => {
            this.showErrorSnackbar("Failed to upload image", result.error.message, response.status);
          },
          response => {
            this.showErrorSnackbar(
              "Failed to upload image",
              "An unknown error has occured",
              response.status
            );
          }
        );
        this.imageUploadPendingCount--;
      });
    } else {
      this.showErrorSnackbar("Failed to upload image", "Feedback code was not generated");
    }
  };

  onImageDelete = (image: Image) => {
    const deleteModel: DeleteImage = {
      fullSizeObjectPath: image.fullSizeObjectPath,
      thumbnailObjectPath: image.thumbnailObjectPath
    };

    imageUploadService.deleteImage(
      endpoints.feedback.images.deleteTemp(),
      deleteModel,
      () => {
        this.setState(prevState => ({
          images: prevState.images.filter(i => i !== image)
        }));
      },
      (response, result) => {
        this.showErrorSnackbar("Failed to remove image", result.error.message, response.status);
      },
      response => {
        this.showErrorSnackbar(
          "Failed to remove image",
          "An unknown error has occured",
          response.status
        );
      }
    );
  };

  onFilesAdded = (files: FeedbackFile[], isCadmakersOnly: boolean) => {
    if (this.props.code) {
      this.fileUploadPendingCount += files.length;

      files.forEach(async file => {
        await fileUploadService.uploadFile(
          endpoints.feedback.files.uploadTemp(this.props.code, isCadmakersOnly),
          file,
          newFile => {
            this.setState(prevState => ({
              files: prevState.files.concat(newFile)
            }));
          },
          hash => {
            return this.state.files.find(x => x.hash === hash);
          },
          () => {
            this.showErrorSnackbar("Failed to upload file", "This file has already been uploaded");
          },
          (response, result) => {
            this.showErrorSnackbar(
              "Failed to upload file",
              result?.error?.message ?? "",
              response.status
            );
          },
          response => {
            this.showErrorSnackbar(
              "Failed to upload file",
              "An unknown error has occured",
              response.status
            );
          }
        );

        this.fileUploadPendingCount--;
      });
    } else {
      this.showErrorSnackbar("Failed to upload file", "Feedback code was not generated");
    }
  };

  onFileDelete = (file: FeedbackFile) => {
    const deleteModel: DeleteFile = {
      path: file.path
    };

    fileUploadService.deleteFile(
      endpoints.feedback.files.deleteTemp(),
      deleteModel,
      () => {
        this.setState(prevState => ({
          files: prevState.files.filter(f => f !== file)
        }));
      },
      (response, result) => {
        this.showErrorSnackbar("Failed to remove file", result.error.message, response.status);
      },
      response => {
        this.showErrorSnackbar(
          "Failed to remove file",
          "An unknown error has occured",
          response.status
        );
      }
    );
  };

  onImageUploadClick = (files: File[]) => {
    this.onImagesAdded(fileService.filestoImages(files));
  };

  onFileUploadClick = (files: File[]) => {
    this.onFilesAdded(fileService.filestoFeedbackFiles(files, false), false);
  };

  onCadmakersFileUploadClick = (files: File[]) => {
    this.onFilesAdded(fileService.filestoFeedbackFiles(files, true), true);
  };

  showErrorSnackbar = (reason: string, errorDescription: string, errorCode?: number) => {
    let label = `${reason}: ${errorDescription}`;

    if (errorCode) {
      label += `(Error Code ${errorCode})`;
    }

    this.props.showSnack("COMMENT_BOX", {
      label,
      timeout: 5000
    });
  };

  loadDefaultsIfNeeded() {
    // check if we need to load the defaults
    if (!this.state.didLoadDefaults) {
      // indicate that we are loading the defaults
      this.setState(
        prevState => {
          return {
            ...prevState,
            didLoadDefaults: true
          };
        },
        () => {
          // load the defaults
          const parsedQuery = queryString.parse(this.props.location.search);

          // load link
          let link: string = "";
          if (parsedQuery.link) {
            link = decodeURIComponent(parsedQuery.link as string);
          }

          // if we got a status code, add it to current behaviour
          let currentBehaviour: string = "";
          if (parsedQuery.errorCode) {
            currentBehaviour = `Receiving Error Code "${parsedQuery.errorCode}"`;
          }

          // update the bug reports with the defaults
          this.props.updateBugReport({
            ...this.props.bugReport,
            link,
            description: currentBehaviour
          });
        }
      );
    }
  }

  render() {
    const isCadmakers = userService.isUserCadmakers(this.props.user);
    return (
      <Form onSubmit={e => this.onSubmit(e)}>
        <Row>
          <Col lg={6}>
            <FeedbackFormInput
              label=" Title (Brief Description)"
              type="text"
              name="title"
              autoComplete="off"
              required
              value={this.state.bugReport.title}
              onChange={e => this.onChange(e)}
              description="This is the displayed title for the bug report. Please make it concise."
            />
          </Col>
          {this.state.bugReport.title.length >= feedbackFormConstants.minLengthForSimilarNames && (
            <Col lg={6}>
              <SimilarFeedbackSuggestionsContainer
                query={this.state.bugReport.title}
                selectedParent={this.props.selectedParent}
                selectedApp={this.props.selectedApp}
                selectedTopic={this.props.selectedTopic}
              />
            </Col>
          )}
        </Row>
        <Row>
          <Col lg={6}>
            <FeedbackFormBugReportTypeInput
              selectedTypeId={this.state.bugReport.tagId}
              onChangeType={this.onChangeType}
            />
          </Col>
          <Col lg={6}>
            <FeedbackFormIsPrivateInput
              isChecked={this.state.bugReport.isPrivate}
              onChange={this.onChangeIsPrivate}
            />
          </Col>
        </Row>
        <FeedbackFormInput
          label="Steps to Reproduce"
          rows={3}
          type="textarea"
          name="reproductionSteps"
          value={this.state.bugReport.reproductionSteps}
          onChange={e => this.onChange(e)}
          description="The steps required to reproduce the bug"
        />
        <FeedbackFormInput
          label="Describe the Bug"
          rows={3}
          type="textarea"
          name="description"
          value={this.state.bugReport.description}
          onChange={e => this.onChange(e)}
          description="Describe the symptoms of the bug"
        />

        <FeedbackFormInput
          label="Expected Behaviour"
          rows={3}
          type="textarea"
          name="expectedBehaviour"
          value={this.state.bugReport.expectedBehaviour}
          onChange={e => this.onChange(e)}
          description="The behaviour that is expected."
        />

        <FormGroup>
          <Label for="link">
            Link&nbsp;<span className="text-danger">*</span>
          </Label>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <span className="input-group-text">
                <Icon
                  appName="GeneralLayout"
                  assetName="GENERAL_L_ChainLink"
                  className={iconStyles.smallIcon}
                />
              </span>
            </InputGroupAddon>
            <Input
              type="text"
              name="link"
              autoComplete="off"
              required
              value={this.state.bugReport.link}
              onChange={e => this.onChange(e)}
            />
          </InputGroup>
          <FormText>A link to the page where the error occured.</FormText>
        </FormGroup>
        <FormGroup>
          <Row>
            {isCadmakers && (
              <Col md={3}>
                <Label for="startDate">
                  <ElementSpacer spacing=".25rem">Start Date</ElementSpacer>
                </Label>
                <div style={{ width: 135 }}>
                  <CalendarPickerInput
                    value={
                      {
                        selectedDate: this.state.bugReport.startDate,
                        actual: this.state.startDateDatePickerActual
                      } as any
                    }
                    onChange={this.onChangeStartDate}
                    onChangeMonth={this.onChangeStartDatepickerActual}
                    disabledDays={[
                      {
                        before: new Date()
                      }
                    ]}
                  />
                </div>
                <FormText>Start date for this task</FormText>
              </Col>
            )}
            <Col md={3}>
              <Label for="dueDate">
                <ElementSpacer spacing=".25rem">Due Date</ElementSpacer>
              </Label>
              <div style={{ width: 135 }}>
                <CalendarPickerInput
                  value={
                    {
                      selectedDate: this.state.bugReport.dueDate,
                      actual: this.state.dueDateDatePickerActual
                    } as any
                  }
                  onChange={this.onChangeDueDate}
                  onChangeMonth={this.onChangeDueDatepickerActual}
                  disabledDays={[
                    {
                      before: new Date()
                    }
                  ]}
                />
              </div>
              <FormText>
                Due date for this feedback to be progressed to the next workflow status
              </FormText>
            </Col>
          </Row>
        </FormGroup>
        {isCadmakers && (
          <FormGroup>
            <Row>
              <Col md={2}>
                <FeedbackFormInput
                  label="Estimated Hours"
                  type="number"
                  name="estimatedHours"
                  autoComplete="off"
                  value={this.state.bugReport.estimatedHours}
                  onChange={e => this.onChange(e)}
                  description="Estimated number of hours for this task."
                  min={0}
                />
              </Col>
            </Row>
          </FormGroup>
        )}

        <Row>
          <Col>
            <ImageDropzone
              images={this.state.images}
              onImagesAdded={this.onImagesAdded}
              onImageDelete={this.onImageDelete}
            />
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <FeedbackFileManager
              files={this.state.files.filter(f => !f.isCadmakersOnly)}
              onFilesAdded={this.onFilesAdded}
              onFileDelete={this.onFileDelete}
              isCadmakersOnly={false}
            />
          </Col>
        </Row>
        {isCadmakers && (
          <Row>
            <Col>
              <br />
              <FeedbackFileManager
                files={this.state.files.filter(f => f.isCadmakersOnly)}
                onFilesAdded={this.onFilesAdded}
                onFileDelete={this.onFileDelete}
                isCadmakersOnly
              />
            </Col>
          </Row>
        )}
        <hr />
        <Row>
          <Col xs="auto">
            <ElementSpacer>
              <Button disabled={!this.state.canSubmit}>Submit</Button>
              <Button onClick={this.clearForm}>Clear</Button>
              <FileUploadButton onClick={this.onImageUploadClick}>Upload Images</FileUploadButton>
              <FileUploadButton onClick={this.onFileUploadClick}>Upload Files</FileUploadButton>
              {isCadmakers && (
                <FileUploadButton onClick={this.onCadmakersFileUploadClick}>
                  Upload Cadmakers Internal Files
                </FileUploadButton>
              )}
            </ElementSpacer>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BugReportForm));
